const initTestimonials = () => {
    const testimonials = document.querySelectorAll('.foodkur-testimonials, .healthy-meals-testimonials__wrapper');

    testimonials.forEach((testimonial) => {
        new Swiper(testimonial.querySelector('.foodkur-testimonials__cardSlider, .hm-testimonials__cardSlider'), {
            spaceBetween: 20,
            slidesPerView: 'auto'
        });
    });
}
window.addEventListener('DOMContentLoaded', () => {
    initTestimonials();
});

